import { Component, OnInit, forwardRef } from "@angular/core";
import { NavController, NavParams, ModalController, IonicModule } from "@ionic/angular";
import { EscalaPessoaPage } from "../../escala-pessoa/escala-pessoa.page";
import { GrupoFiltroPage } from "../../grupo/grupo-filtro/grupo-filtro.page";
import { EscalaProvider } from "src/app/services/escala/escala";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { SemRegistroComponent } from "src/app/components/sem-registro/sem-registro";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { NomenclaturaPipe } from "src/app/pipes/nomenclatura/nomenclatura";

//
@Component({
  selector: "app-escala-grupo",
  templateUrl: "./escala-grupo.page.html",
  styleUrls: ["./escala-grupo.page.scss"],
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule, SemRegistroComponent, TranslateModule, NomenclaturaPipe],
})
export class EscalaGrupoPage implements OnInit {
  tipo: number;
  permissao: any;
  filtroExterno: any = { dia: null, tipo: null, regiao: null };
  pagination: any = { currentPage: 0, pageCount: 0 };
  grupoList: any = [];
  idEntidade = "";
  entidade = "";
  tipoGrupo = "";
  idEscala = "";
  regiao = "";
  filtro = "";
  dia = "";
  filtroTipos: any;
  regioes: any;

  diaSemanaList: any = [
    { id: 0 || null, nome: this.translate.instant("TODOS") },
    { id: "1", nome: this.translate.instant("Domingo") },
    { id: "2", nome: this.translate.instant("Segunda-Feira") },
    { id: "3", nome: this.translate.instant("Terça-Feira") },
    { id: "4", nome: this.translate.instant("Quarta-Feira") },
    { id: "5", nome: this.translate.instant("Quinta-Feira") },
    { id: "6", nome: this.translate.instant("Sexta-Feira") },
    { id: "7", nome: this.translate.instant("Sábado") },
  ];
  nomeTipoGrupo: any;
  nomeRegiao: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public escalaProvider: EscalaProvider,
    public modalCtrl: ModalController,
    private translate: TranslateService
  ) {
    this.tipo = this.navParams.get("tipo");
    this.permissao = this.navParams.get("permissao");
    this.entidade = this.navParams.get("entidade");
    this.idEntidade = this.navParams.get("idEntidade");
    this.idEscala = this.navParams.get("idEscala");
    this.loadGrupos(null);
  }

  ngOnInit() {}

  loadGrupos(infiniteScroll: { target: { complete: () => void } } | null) {
    this.pagination.currentPage++;

    if (!infiniteScroll) {
      this.pagination = { currentPage: 0, pageCount: 10 };
    }

    this.escalaProvider
      .getGrupos(this.filtro, this.tipoGrupo, this.regiao, this.dia, this.tipo, this.pagination)
      .subscribe((res) => {
        if (!infiniteScroll) {
          this.grupoList = [];
        }

        this.grupoList = this.grupoList.concat(res.grupos);
        this.pagination = res.pagination;

        if (infiniteScroll) infiniteScroll.target.complete();
      });
  }

  onCancel() {
    this.pagination = { currentPage: 0, pageCount: 0 };
  }

  onInput() {
    this.loadGrupos(null);
  }

  async filtrar() {
    const data = { filtro: this.filtroExterno, tipo: this.tipo };
    const modalPage = await this.modalCtrl.create({
      component: GrupoFiltroPage,
      componentProps: data,
    });
    modalPage.present();

    const filtro = await modalPage.onDidDismiss();
    if (filtro.data) {
      this.filtroExterno = filtro.data;
      this.dia = filtro.data.dia;
      this.tipoGrupo = filtro.data.tipo;
      this.nomeTipoGrupo = filtro.data.nomeTipo; 
      this.nomeRegiao = filtro.data.nomeRegiao;
      this.loadGrupos(null);
    }
  }

  getNomeTipo(id: any) {
    return this.filtroTipos?.find((t: any) => t.id == id)?.nome || "Tipo";
  }

  getNomeDia(id: string): string {
    return this.diaSemanaList?.find((d: any) => d.id === id)?.nome || id;
  }

  getNomeRegiao(id: any) {
    return this.regioes?.find((r: any) => r.id == id)?.nome || "Região";
  }

  removerFiltro(chave: "tipo" | "dia" | "regiao") {
    if (chave === "tipo") {
      this.tipoGrupo = "";
      this.filtroExterno.tipo = "";
    } else if (chave === "dia") {
      this.dia = "";
      this.filtroExterno.dia = "";
    } else if (chave === "regiao") {
      this.nomeRegiao = "";
      this.filtroExterno.regiao = "";
    }

    this.loadGrupos(null);
  }

  async selecionarGrupo(id: any) {
    let data = {
      grupo: id,
      entidade: this.entidade,
      idEntidade: this.idEntidade,
      idEscala: this.idEscala,
    };
    const modalPage = await this.modalCtrl.create({
      component: EscalaPessoaPage,
      componentProps: data,
    });
    modalPage.present();
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }
}
